import { FC, MouseEventHandler, ReactNode } from 'react';

import { Link } from '@inertiajs/react';

import { cn } from '../utils';

const NavItem: FC<{
    href?: string;
    icon: ReactNode;
    label: string;
    active?: boolean;
    onClick?: MouseEventHandler;
}> = ({ href, icon, label, active = false, onClick }) => {
    const className = cn(
        'flex flex-col items-center justify-center gap-1 p-1 w-full h-full',
        active && 'text-primary',
    );

    if (href) {
        return (
            <Link
                href={href}
                className={className}
                onClick={(e) => onClick?.(e)}
            >
                <div
                    className={cn(
                        'rounded-full p-1.5',
                        active && 'bg-primary/10',
                    )}
                >
                    {icon}
                </div>
                <span className="text-[10px]">{label}</span>
            </Link>
        );
    }

    return (
        <button className={className} onClick={onClick}>
            <div
                className={cn('rounded-full p-1.5', active && 'bg-primary/10')}
            >
                {icon}
            </div>
            <span className="text-[10px]">{label}</span>
        </button>
    );
};

export default {
    NavItem,
};
